
// Small reusable collapsible header+content pair. Used both for the
// Indstillinger section itself (nested at the same sidebar level as
// Registreringer/Properties/Export - see sidebar.html) and for each tool
// sub-group inside it (Generelt/Punkt/Linje/.../Rør).
//
// Deliberately its own thing rather than reusing sidebar.js's
// initAccordion() (the `$('.accordion > h3')` wiring that makes
// Rendering/Tools/Scene/Digitalisering/... foldable): that selector only
// targets *direct* children of the top-level `.accordion` list, so it can't
// reach elements nested inside Digitalisering's own content - these need
// their own toggle, which is what this helper provides once, for reuse by
// both nesting levels.
//
// Returns {header, content} as plain DOM elements; `content` starts hidden
// unless `startOpen` is true, and toggles open/closed only in response to a
// click on its own `header` - nothing else opens or closes a section
// programmatically. `level` is "section" (the outer Indstillinger bar) or
// "group" (an inner tool sub-group) - see potree.css for the matching
// `.digitization-settings-header` / `-subheader` styling.
export function createCollapsibleSection(title, {startOpen = false, level = "section"} = {}){
	const headerClass = level === "section" ? "digitization-settings-header" : "digitization-settings-subheader";

	const header = document.createElement("div");
	header.className = headerClass;
	const caret = document.createElement("span");
	caret.className = "digitization-settings-caret";
	caret.textContent = startOpen ? "▾" : "▸";
	const titleEl = document.createElement("span");
	titleEl.textContent = title;
	header.append(caret, titleEl);

	const content = document.createElement("div");
	content.className = "digitization-settings-content";
	let isOpen = startOpen;
	if(!startOpen) content.style.display = "none";

	function setOpen(next){
		if(next === isOpen) return;
		isOpen = next;
		// no jQuery slideToggle() available - an instant show/hide is fine
		// for a settings panel (not an animation-critical interaction)
		content.style.display = isOpen ? "" : "none";
		caret.textContent = isOpen ? "▾" : "▸";
	}

	header.addEventListener("click", () => setOpen(!isOpen));

	return {header, content};
}
